module.exports = __webpack_public_path__ + "8bca19221859c92b01729a523c68bcaf.svg";